/*
 * Mascote Lottie (load-more) — porta o DotLottieReact do
 * PaginatedResourceSection.tsx usando o dotlottie-web vendorizado.
 * O runtime WASM vem do CDN padrão do dotlottie-web (jsdelivr), o mesmo
 * usado pelo player React no site Hydrogen (estava allowlisted no CSP).
 */
async function init() {
  const holders = [...document.querySelectorAll('.high-lottie')];
  if (!holders.length) return;

  const moduleUrl = holders[0].dataset.lottieModule;
  if (!moduleUrl) return;

  try {
    const {DotLottie} = await import(moduleUrl);
    holders.forEach((holder) => {
      if (holder.dataset.lottieMounted) return;
      const canvas = holder.querySelector('canvas');
      if (!canvas) return;
      new DotLottie({
        canvas,
        src: holder.dataset.lottieSrc,
        loop: true,
        autoplay: true,
        speed: 1.6,
      });
      holder.dataset.lottieMounted = 'true';
    });
  } catch (error) {
    // Sem player, os elementos seguem como links funcionais.
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
